$bog_gram $mol_book2
	plugins /
		<= Theme $mol_theme_auto
		<= Favicon $bog_favicon
			Icon <= Favicon_icon $mol_icon_message
	Placeholder <= Intro $mol_view
		sub /
			<= Intro_plate $mol_view
				sub /
					<= Intro_title $mol_paragraph
						title \Выберите диалог
					<= Intro_hint $mol_paragraph
						title \Или начните новый: кнопка в шапке списка
	pages /
		<= Menu $mol_page
			title \Gram
			tools /
				<= Status $giper_baza_status
				<= Compose_open $mol_button_minor
					hint \Новый диалог
					click? <=> compose_open? null
					sub /
						<= Compose_open_icon $mol_icon_message_plus
				<= Group_open $mol_button_minor
					hint \Новая группа
					click? <=> group_open? null
					sub /
						<= Group_open_icon $mol_icon_account_multiple_plus
				<= Settings_open $mol_button_minor
					hint \Настройки
					click? <=> settings_open? null
					sub /
						<= Settings_open_icon $mol_icon_cog
				<= Lights $mol_lights_toggle
			body /
				<= Invite_plate $mol_view
					sub /
						<= Invite_plate_text $mol_paragraph
							title <= invite_plate_text \
						<= Invite_drop $mol_button_minor
							hint \Отменить
							click? <=> invite_drop? null
							sub /
								<= Invite_drop_icon $mol_icon_close
				<= Ask_plate $mol_view
					sub /
						<= Ask_plate_text $mol_paragraph
							title <= ask_plate_text \
				<= Dialogs_list $mol_list
					rows <= dialog_rows /
		<= Settings_page $mol_page
			title \Настройки
			tools /
				<= Settings_close $mol_button_minor
					hint \Закрыть
					click? <=> settings_close? null
					sub /
						<= Settings_close_icon $mol_icon_close
			body /
				<= Name_field $bog_gram_field
					hint \Ваше имя
					value? <=> user_name? \
				<= My_id $mol_labeler
					title \Мой ID
					content /
						<= My_id_text $mol_paragraph
							title <= my_lord \
						<= My_id_copy $mol_button_copy
							title \Скопировать
							text <= my_lord
				<= Invite $mol_labeler
					title \Ссылка на меня
					content /
						<= Invite_body $mol_view
							sub /
								<= Invite_hint $mol_paragraph
									title \Отправьте эту ссылку — у собеседника сразу откроется диалог с вами
								<= Invite_text $mol_paragraph
									title <= invite_link \
								<= Invite_copy $mol_button_copy
									title \Скопировать
									text <= invite_link
								<= Invite_qr_box $mol_view
									sub /
										<= Invite_qr $bog_qr
											uri <= invite_link
											gradient_stops /
												\#229ED9
												\#5ED0F5
				<= Notify $mol_labeler
					title \Уведомления
					content /
						<= Notify_body $mol_view
							sub /
								<= Notify_status $mol_paragraph
									title <= notify_status \
								<= Notify_toggle $mol_button_major
									click? <=> notify_toggle? null
									sub /
										<= notify_label \
				<= Registry_block $mol_labeler
					title \Реестры
					content <= registry_content /
				<= Account $mol_labeler
					title \Аккаунт
					content /
						<= Account_body $mol_view
							sub <= account_rows /
		<= Compose_page $mol_page
			title \Новый диалог
			tools /
				<= Compose_close $mol_button_minor
					hint \Закрыть
					click? <=> compose_close? null
					sub /
						<= Compose_close_icon $mol_icon_close
			body /
				<= Peer_form $mol_view
					sub /
						<= Peer_field $mol_string
							hint \ID собеседника
							value? <=> peer_lord? \
							submit? <=> dialog_start? null
						<= Peer_start $mol_button_major
							click? <=> dialog_start? null
							sub /
								\Начать диалог
				<= Users_title $mol_paragraph
					title \Пользователи
				<= Join_plate $mol_view
					sub /
						<= Join_plate_text $mol_paragraph
							title \Вас нет в этом реестре — другие вас тут не найдут
						<= Join_plate_button $mol_button_major
							click? <=> registry_join_active? null
							sub /
								\Вступить
				<= Users_list $mol_list
					rows <= user_rows /
		<= Group_page $mol_page
			title \Новая группа
			tools /
				<= Group_close $mol_button_minor
					hint \Закрыть
					click? <=> group_close? null
					sub /
						<= Group_close_icon $mol_icon_close
			body /
				<= Group_name_field $mol_string
					hint \Название группы
					value? <=> group_name? \
				<= Group_chosen_head $mol_paragraph
					title <= group_chosen_head \
				<= Group_chosen_list $mol_list
					rows <= group_chosen_rows /
				<= Group_lost_note $mol_paragraph
					title <= group_lost_note \
				<= Group_make $mol_button_major
					click? <=> group_make? null
					sub /
						<= group_make_label \
				<= Group_id_form $mol_view
					sub /
						<= Group_id_field $mol_string
							hint \ID участника
							value? <=> group_id? \
							submit? <=> group_id_add? null
						<= Group_id_add $mol_button_major
							click? <=> group_id_add? null
							sub /
								\Добавить
				<= Group_id_error $mol_paragraph
					title <= group_id_error \
				<= Group_pick_head $mol_paragraph
					title \Кого позвать
				<= Group_pick_list $mol_list
					rows <= group_pick_rows /
		<= Members_page $mol_page
			title \Участники
			tools /
				<= Members_close $mol_button_minor
					hint \Закрыть
					click? <=> members_close? null
					sub /
						<= Members_close_icon $mol_icon_close
			body /
				<= Members_list $mol_list
					rows <= member_rows /
				<= Members_drop_note $mol_paragraph
					title \«Убрать» заводит новый отсек переписки без человека. Прошлые сообщения у него останутся: ключ от них уже выдан, и отобрать его нечем. Новых он не увидит.
				<= Members_add_block $mol_view
					sub <= members_add_rows /
				<= Members_leave_note $mol_paragraph
					title \«Выйти» убирает группу из вашего списка. У остальных она остаётся, и ваши прошлые сообщения в ней тоже.
				<= Members_leave $mol_button_minor
					hint \Убрать группу из своего списка
					attr *
						^
						bog_gram_armed <= leave_armed false
					click? <=> group_leave_click? null
					sub /
						<= group_leave_label \
		<= Chat_page $bog_gram_chat
			title <= chat_title \
			members_shown <= chat_members_shown false
			members? <=> members_open? null
			note? <=> chat_note? \
			note_hint <= chat_note_hint \
			note_editable <= chat_note_editable false
			rows <= chat_rows /
			edit_mode <= edit_mode false
			message_text? <=> message_text? \
			message_send? <=> message_send? null
			edit_cancel? <=> edit_cancel? null
			close? <=> dialog_close? null
			image_files? <=> image_files? null
			image_paste? <=> image_paste? null
			image_over? <=> image_over? null
			image_drop? <=> image_drop? null
			zoom_uri <= zoom_uri \
			zoom_close? <=> zoom_close? null
			voice_on <= voice_on false
			voice_ready <= voice_ready false
			voice_clock <= voice_clock \
			voice_hint <= voice_hint \
			voice_press? <=> voice_press? null
			voice_release? <=> voice_release? null
			voice_abort? <=> voice_abort? null
			voice_cancel? <=> voice_cancel? null
			voice_menu? <=> voice_menu? null
	Dialogs_empty $mol_view
		sub /
			<= Dialogs_empty_text $mol_paragraph
				title \Пока нет диалогов
	Users_empty $mol_view
		sub /
			<= Users_empty_text $mol_paragraph
				title <= users_empty_text \
	Registry_empty $mol_paragraph
		title \Вы не состоите ни в одном реестре
	Registry_list $mol_list
		rows <= registry_rows /
	Registry_note $mol_paragraph
		title \Убрать можно только из своего списка: запись в самом реестре остаётся навсегда.
	Registry_share $mol_view
		sub /
			<= Registry_share_text $mol_paragraph
				title \Ссылка-приглашение в активный реестр
			<= Registry_share_copy $mol_button_copy
				title \Скопировать ссылку
				text <= registry_uri \
	Registry_form $mol_view
		sub /
			<= Registry_name $mol_string
				hint \Название реестра
				value? <=> registry_name? \
				submit? <=> registry_make? null
			<= Registry_make $mol_button_major
				click? <=> registry_make? null
				sub /
					\Создать реестр
	Registry_row* $mol_button_minor
		click? <=> registry_open*? null
		attr *
			^
			bog_gram_current <= registry_active_is* false
		sub /
			<= Registry_info* $mol_view
				sub /
					<= Registry_title* $mol_view
						sub /
							<= registry_title* \
					<= Registry_status* $mol_view
						sub /
							<= registry_status* \
			<= Registry_join* $mol_button_minor
				hint \Вступить в реестр
				click? <=> registry_join*? null
				sub /
					\Вступить
			<= Registry_drop* $mol_button_minor
				hint \Убрать из своего списка
				click? <=> registry_forget*? null
				sub /
					<= Registry_drop_icon* $mol_icon_close
	Key_toggle $mol_button_minor
		click? <=> key_toggle? null
		sub /
			<= key_toggle_label \
	Key_warning $mol_paragraph
		title \Ключ — это полный доступ к аккаунту. Не показывайте его никому и не публикуйте.
	Key_row $mol_view
		sub /
			<= Key_text $mol_paragraph
				title <= key_text \
			<= Key_copy $mol_button_copy
				title \Скопировать
				text <= key_text
	Key_qr_box $mol_view
		sub /
			<= Key_qr $bog_qr
				uri <= key_text
				gradient_stops /
					\#e14b4b
					\#f0a04b
	Key_save $mol_button_minor
		click? <=> key_save? null
		sub /
			\Скачать файл
	Key_import_form $mol_view
		sub /
			<= Key_field $mol_string
				hint \Ключ аккаунта
				value? <=> key_input? \
			<= Key_load_row $mol_view
				sub /
					<= Key_load_hint $mol_paragraph
						title \Или загрузите файл с ключом
					<= Key_open $mol_button_open
						hint \Выбрать файл
						accept \.key,text/plain
						multiple false
						files? <=> key_file? null
			<= Key_scan $bog_gram_scan
				found? <=> key_scanned? \
			<= Key_import $mol_button_major
				attr *
					^
					bog_gram_armed <= import_armed false
				click? <=> key_import? null
				sub /
					<= key_import_label \
			<= Key_error $mol_paragraph
				title <= key_error \
	Dialog_row* $mol_button_minor
		click? <=> dialog_select*? null
		attr *
			^
			bog_gram_current <= dialog_current_is* false
		sub /
			<= Dialog_avatar* $bog_gram_avatar
				id <= dialog_avatar_id* \
				tint <= dialog_tint* 0
			<= Dialog_info* $mol_view
				sub /
					<= Dialog_top* $mol_view
						sub /
							<= Dialog_title* $mol_view
								sub /
									<= dialog_title* \
							<= Dialog_time* $mol_view
								sub /
									<= dialog_time* \
					<= Dialog_bottom* $mol_view
						sub /
							<= Dialog_preview* $mol_view
								sub /
									<= dialog_preview* \
							<= Unread_badge* $mol_view
								sub /
									<= unread_label* \
			<= Dialog_archive* $mol_button_minor
				hint <= archive_hint* \
				click? <=> dialog_archive_click*? null
				sub <= archive_icons* /
			<= Dialog_delete* $mol_button_minor
				hint <= delete_hint* \
				attr *
					^
					bog_gram_armed <= delete_armed* false
				click? <=> dialog_delete_click*? null
				sub /
					<= Dialog_delete_icon* $mol_icon_delete
	Dialog_archive_icon* $mol_icon_archive_arrow_down
	Dialog_unarchive_icon* $mol_icon_archive_arrow_up
	Saved_row $mol_button_minor
		hint \Заметки для себя
		click? <=> saved_open? null
		attr *
			^
			bog_gram_current <= saved_current_is false
		sub /
			<= Saved_avatar $mol_view
				sub /
					<= Saved_avatar_icon $mol_icon_bookmark
			<= Saved_info $mol_view
				sub /
					<= Saved_top $mol_view
						sub /
							<= Saved_title $mol_view
								sub /
									<= saved_title \
							<= Saved_time $mol_view
								sub /
									<= saved_time \
					<= Saved_bottom $mol_view
						sub /
							<= Saved_preview $mol_view
								sub /
									<= saved_preview \
	Archive_row $mol_button_minor
		hint \Спрятанные диалоги
		click? <=> archive_toggle? null
		sub /
			<= Archive_avatar $mol_view
				sub /
					<= Archive_avatar_icon $mol_icon_archive
			<= Archive_info $mol_view
				sub /
					<= Archive_title $mol_view
						sub /
							\Архив
					<= Archive_note $mol_view
						sub /
							<= archive_note \
			<= Archive_unread $mol_view
				sub /
					<= archive_unread_label \
	Requests_row $mol_button_minor
		hint \Запросы на переписку
		click? <=> requests_toggle? null
		sub /
			<= Requests_avatar $mol_view
				sub /
					<= Requests_avatar_icon $mol_icon_account_question
			<= Requests_info $mol_view
				sub /
					<= Requests_title $mol_view
						sub /
							\Запросы
					<= Requests_note $mol_view
						sub /
							\Хотят вам написать
			<= Requests_count $mol_view
				sub /
					<= requests_count_label \
	Request_accept* $mol_button_minor
		hint \Принять
		click? <=> request_accept*? null
		sub /
			<= Request_accept_icon* $mol_icon_check
	Request_reject* $mol_button_minor
		hint \Отклонить
		click? <=> request_reject*? null
		sub /
			<= Request_reject_icon* $mol_icon_close
	User_row* $mol_button_minor
		click? <=> user_pick*? null
		sub /
			<= User_avatar* $bog_gram_avatar
				id <= user_lord* \
				tint <= user_tint* 0
			<= User_info* $mol_view
				sub /
					<= User_title* $mol_view
						sub /
							<= user_title* \
					<= User_source* $mol_view
						sub /
							<= user_source* \
	Group_pick_row* $mol_button_minor
		click? <=> group_pick*? null
		attr *
			^
			bog_gram_current <= group_picked_is* false
		sub /
			<= Group_pick_avatar* $bog_gram_avatar
				id <= group_pick_lord* \
				tint <= group_pick_tint* 0
			<= Group_pick_info* $mol_view
				sub /
					<= Group_pick_title* $mol_view
						sub /
							<= group_pick_title* \
					<= Group_pick_source* $mol_view
						sub /
							<= group_pick_source* \
			<= Group_pick_mark* $mol_icon_check
	Group_chosen_row* $mol_view
		sub /
			<= Group_chosen_avatar* $bog_gram_avatar
				id <= group_chosen_lord* \
				tint <= group_chosen_tint* 0
			<= Group_chosen_name* $mol_view
				sub /
					<= group_chosen_name* \
			<= Group_chosen_drop* $mol_button_minor
				hint \Убрать из списка
				click? <=> group_chosen_drop*? null
				sub /
					<= Group_chosen_drop_icon* $mol_icon_close
	Members_add_title $mol_paragraph
		title \Добавить участника
	Members_history $mol_view
		sub /
			<= Members_history_head $mol_paragraph
				title \Что увидит новый участник
			<= Members_history_row $mol_view
				sub /
					<= Members_history_all $mol_button_minor
						hint \Выдать ключи от всех прошлых сообщений
						attr *
							^
							bog_gram_current <= history_open false
						click? <=> members_history_all? null
						sub /
							\Всю переписку
					<= Members_history_new $mol_button_minor
						hint \Завести новый отсек переписки
						attr *
							^
							bog_gram_current <= history_shut false
						click? <=> members_history_new? null
						sub /
							\Только новые
			<= Members_history_note $mol_paragraph
				title <= members_history_note \
	Members_error $mol_paragraph
		title <= member_error \
	Members_id_form $mol_view
		sub /
			<= Members_id_field $mol_string
				hint \ID участника
				value? <=> member_id? \
				submit? <=> member_id_add? null
			<= Members_id_add $mol_button_major
				click? <=> member_id_add? null
				sub /
					\Добавить
	Members_pick_list $mol_list
		rows <= member_pick_rows /
	Members_admin_note $mol_paragraph
		title \Админ получает полное управление лендом: он сможет и звать людей, и менять чужие права. Разделить эти способности нечем.
	Members_join $mol_view
		sub /
			<= Members_join_head $mol_paragraph
				title \Ссылка-приглашение в группу
			<= Members_join_hint $mol_paragraph
				title \Мгновенно по ней не вступишь: перешедший пришлёт заявку, а принимать её вам — ключ от переписки выдаётся человеку поимённо
			<= Members_join_text $mol_paragraph
				title <= join_link \
			<= Members_join_copy $mol_button_copy
				title \Скопировать
				text <= join_link
			<= Members_join_qr_box $mol_view
				sub /
					<= Members_join_qr $bog_qr
						uri <= join_link
						gradient_stops /
							\#2f9e5f
							\#8fd14f
	Members_asks_head $mol_paragraph
		title <= members_asks_head \
	Members_asks_list $mol_list
		rows <= members_ask_rows /
	Ask_row* $mol_view
		sub /
			<= Ask_avatar* $bog_gram_avatar
				id <= ask_lord* \
				tint <= ask_tint* 0
			<= Ask_info* $mol_view
				sub /
					<= Ask_title* $mol_view
						sub /
							<= ask_title* \
					<= Ask_status* $mol_view
						sub /
							<= ask_status* \
			<= Ask_accept* $mol_button_minor
				hint \Принять в группу
				click? <=> ask_accept*? null
				sub /
					<= Ask_accept_icon* $mol_icon_check
			<= Ask_reject* $mol_button_minor
				hint \Отклонить заявку
				click? <=> ask_reject*? null
				sub /
					<= Ask_reject_icon* $mol_icon_close
	Member_row* $mol_view
		sub /
			<= Member_avatar* $bog_gram_avatar
				id <= member_lord* \
				tint <= member_tint* 0
			<= Member_info* $mol_view
				sub /
					<= Member_title* $mol_view
						sub /
							<= member_title* \
					<= Member_status* $mol_view
						sub /
							<= member_status* \
			<= Member_rule* $mol_button_minor
				hint \Назначить админом
				click? <=> member_rule_click*? null
				sub /
					<= Member_rule_icon* $mol_icon_shield_crown
			<= Member_drop* $mol_button_minor
				hint <= member_drop_hint* \
				attr *
					^
					bog_gram_armed <= member_armed* false
				click? <=> member_drop_click*? null
				sub /
					<= Member_drop_icon* $mol_icon_account_remove
	Member_pick_row* $mol_button_minor
		click? <=> member_pick*? null
		sub /
			<= Member_pick_avatar* $bog_gram_avatar
				id <= member_pick_lord* \
				tint <= member_pick_tint* 0
			<= Member_pick_info* $mol_view
				sub /
					<= Member_pick_title* $mol_view
						sub /
							<= member_pick_title* \
					<= Member_pick_source* $mol_view
						sub /
							<= member_pick_source* \
			<= Member_pick_mark* $mol_icon_account_plus
	Day_row* $mol_view
		sub /
			<= Day_chip* $mol_view
				sub /
					<= day_title* \
	Message_row* $mol_view
		attr *
			^
			bog_gram_out <= message_out* false
			bog_gram_menu <= message_menu_is* false
		event *
			^
			pointerdown? <=> message_press*? null
			pointerup? <=> message_release*? null
			pointercancel? <=> message_release*? null
			contextmenu? <=> message_context*? null
		sub /
			<= Message_author* $mol_view
				attr *
					^
					bog_gram_tint <= message_author_tint* 0
				sub /
					<= message_author* \
			<= Message_shot* $bog_gram_photo
				hint \Открыть картинку
				uri <= message_shot_uri* \
				box_width <= message_shot_width* \
				box_ratio <= message_shot_ratio* \
				click? <=> message_zoom*? null
			<= Message_sound* $bog_gram_sound
				uri <= message_sound_uri* \
				span <= message_sound_span* 0
				playing <= message_sound_playing* false
				toggle? <=> message_sound_toggle*? null
				ended? <=> message_sound_ended*? null
			<= Message_body* $mol_paragraph
				title <= message_body* \
			<= Message_meta* $mol_view
				sub /
					<= Message_time* $mol_view
						sub /
							<= message_time* \
					<= Message_edited* $mol_view
						sub /
							\изменено
					<= Message_checks* $mol_view
						sub /
							<= message_checks* \
			<= Message_actions* $mol_view
				sub /
					<= Message_edit* $mol_button_minor
						hint \Редактировать
						click? <=> message_edit*? null
						sub /
							<= Message_edit_icon* $mol_icon_pencil
					<= Message_delete* $mol_button_minor
						hint \Удалить
						click? <=> message_delete*? null
						sub /
							<= Message_delete_icon* $mol_icon_delete

$bog_gram_field $mol_view
	hint \
	value? \
	sub /
		<= Field $mol_string_button
			hint <= hint
			value? <=> value? \
		<= Edit_icon $mol_icon_pencil

$bog_gram_chat $mol_page
	rows /$mol_view
	edit_mode false
	message_text? \
	message_send? null
	edit_cancel? null
	close? null
	note_editable false
	members_shown false
	members? null
	image_files? null
	image_paste? null
	image_over? null
	image_drop? null
	zoom_uri \
	zoom_close? null
	voice_on false
	voice_ready false
	voice_clock \
	voice_hint \
	voice_press? null
	voice_release? null
	voice_abort? null
	voice_cancel? null
	voice_menu? null
	event *
		^
		paste? <=> image_paste? null
		dragover? <=> image_over? null
		drop? <=> image_drop? null
	Zoom $bog_gram_zoom
		uri <= zoom_uri
		close? <=> zoom_close? null
	title_content /
		<= Note_field $bog_gram_field
			hint <= note_hint \
			value? <=> note? \
		<= Title_text $mol_view
			sub /
				<= title
	head /
		<= Back $mol_button_minor
			hint \Назад
			click? <=> close? null
			sub /
				<= Back_icon $mol_icon_arrow_left
		<= Title
		<= Tools
	tools /
		<= Members $mol_button_minor
			hint \Участники
			click? <=> members? null
			sub /
				<= Members_icon $mol_icon_account_multiple
		<= Close $mol_button_minor
			hint \Закрыть
			click? <=> close? null
			sub /
				<= Close_icon $mol_icon_close
	body /
		<= Messages $mol_list
			rows <= rows
	foot /
		<= Foot $mol_view
			sub /
				<= Edit_banner $mol_view
					sub /
						<= Edit_banner_text $mol_paragraph
							title \Редактирование
						<= Edit_cancel $mol_button_minor
							hint \Отменить правку
							click? <=> edit_cancel? null
							sub /
								<= Edit_cancel_icon $mol_icon_close
				<= Voice_note $mol_paragraph
					title <= voice_hint
				<= Send_row $mol_view
					sub <= send_tools /
	Attach $mol_button_open
		hint \Отправить картинку
		accept \image/*
		multiple false
		files? <=> image_files? null
		Icon <= Attach_icon $mol_icon_paperclip
	Message_field $mol_string
		hint \Сообщение…
		value? <=> message_text? \
		submit? <=> message_send? null
	Send $mol_button_major
		hint \Отправить
		click? <=> message_send? null
		sub /
			<= Send_icon $mol_icon_send
	Voice $mol_button_minor
		hint \Удерживайте для записи
		event *
			^
			pointerdown? <=> voice_press? null
			pointerup? <=> voice_release? null
			pointercancel? <=> voice_abort? null
			contextmenu? <=> voice_menu? null
		sub /
			<= Voice_icon $mol_icon_microphone
	Record_state $mol_view
		sub /
			<= Record_dot $mol_view
			<= Record_time $mol_view
				sub /
					<= voice_clock
	Voice_cancel $mol_button_minor
		hint \Отпустите здесь, чтобы отменить
		click? <=> voice_cancel? null
		sub /
			<= Voice_cancel_icon $mol_icon_close
			<= Voice_cancel_text $mol_view
				sub /
					\Отмена

$bog_gram_avatar $mol_avatar
	id \
	tint 0
	attr *
		^
		bog_gram_tint <= tint

$bog_gram_photo $mol_button
	uri \
	box_width \15rem
	box_ratio \1
	style *
		width <= box_width
		aspectRatio <= box_ratio
	sub /
		<= Image $mol_image
			uri <= uri

$bog_gram_sound $mol_view
	uri \
	span 0
	playing false
	toggle? null
	ended? null
	sub /
		<= Toggle $mol_button_minor
			hint \Прослушать
			click? <=> toggle? null
			sub <= toggle_icons /
		<= Track $mol_view
			sub /
				<= Fill $mol_view
					style *
						width <= fill_width \0%
		<= Stamp $mol_view
			sub /
				<= stamp \
		<= Node $bog_gram_sound_node
			uri <= uri
			ended? <=> ended? null
	Play_icon $mol_icon_play
	Pause_icon $mol_icon_pause

$bog_gram_sound_node $mol_view
	dom_name \audio
	uri \
	retime? null
	ended? null
	attr *
		^
		src <= uri
		preload \metadata
	event *
		^
		timeupdate? <=> retime? null
		ended? <=> ended? null

$bog_gram_zoom $mol_view
	uri \
	close? null
	attr *
		^
		tabindex <= tab_index 0
	event *
		^
		click? <=> close? null
	plugins /
		<= Hotkey $mol_hotkey
			key * escape? <=> close? null
	sub /
		<= Shot $mol_image
			uri <= uri
